import style from "./CertificateCard.module.css";

import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

import Icon from "@/ui/icon/Icon";
import certificateSvg1 from "@/assets/images/certificates/1.svg";
import certificateSvg2 from "@/assets/images/certificates/2.svg";
import certificateSvg3 from "@/assets/images/certificates/3.svg";

import { padZero, secondsToHoursMinutes } from "@/utils/helpers";
import { formatShortDate } from "@/i18n/format";
import { useCurrentLanguage, useLocalized } from "@/i18n/useLocalized";

// The category shown on a certificate, by the code in its ID.
const CATEGORY_LABELS = {
	biz: "courses:certificate.categories.biz",
	teh: "courses:certificate.categories.teh",
	kre: "courses:certificate.categories.kre",
};

function CertificateCard({ certificate }) {
	const { t } = useTranslation();
	const language = useCurrentLanguage();
	const l = useLocalized();
	const { course } = certificate;
	const category =
		certificate?.certificate_id.split("-")[1]?.toLowerCase() ||
		course?.categories[0].slug.substring(0, 3);
	return (
		<div className={style.card}>
			<Link
				to={`/certificates/${certificate?.certificate_id}`}
				className={style.imgHolder}
			>
				<img
					src={
						certificate?.image_png ??
						{
							kre: certificateSvg1,
							biz: certificateSvg2,
							teh: certificateSvg3,
						}[category]
					}
				></img>
			</Link>
			<div className={style.info}>
				<div className={style.category}>
					<Icon
						icon={
							{
								biz: "fa-briefcase-blank",
								teh: "fa-desktop",
								kre: "fa-palette",
							}[category]
						}
					/>
					<span>
						{CATEGORY_LABELS[category] &&
							t(CATEGORY_LABELS[category])}
					</span>
				</div>
				<h3>{l(course, "name")}</h3>
				<div className={style.footer}>
					<div className={style.btnHolder}>
						<Link
							to={`/certificates/${certificate?.certificate_id}`}
						>
							{t("courses:certificate.viewMore")}
						</Link>
						<Icon icon="fa-arrow-right" />
					</div>
					<div className={style.moreInfo}>
						<div className={style.item}>
							<Icon icon="fa-calendar" />
							<span>
								{formatShortDate(certificate?.time_issued, language)}
							</span>
						</div>
						<span></span>
						<div className={style.item}>
							<Icon icon="fa-layer-group" />
							<span>{padZero(course?.module_count)}</span>
						</div>
						<span></span>
						<div className={style.item}>
							<Icon icon="fa-clock" />
							<span>
								{secondsToHoursMinutes(course?.duration)}
							</span>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}

export default CertificateCard;
